import { render, staticRenderFns } from "./SuperuserDashboardWrapper.vue?vue&type=template&id=01b66578&"
var script = {}
import style0 from "./SuperuserDashboardWrapper.vue?vue&type=style&index=0&id=01b66578&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports